/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import StringMask from 'string-mask';
import Lottie from 'react-lottie';
import { FaEdit, FaTrashAlt, FaFileAlt, FaEye, FaCog } from 'react-icons/fa';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import api, { baseURL } from '../../../services/api.js';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ModernActionMenu from '../../../components/ModernActionMenu/index.js';
import GenericActionMenu from '../../../components/GenericActionMenu/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';

const StudyList = () => {
  document.title = 'Enermerco - Estudos';
  const [isLoading, setIsLoading] = useState(true);

  const [studyList, setStudyList] = useState([]);

  const [studyIdDm014, setStudyIdDm014] = useState('');
  const [studyStatus, setStudyStatus] = useState(0);
  const [studyCnpj, setStudyCnpj] = useState('');
  const [studyName, setStudyName] = useState('');

  const [modalStatus, setModalStatus] = useState(false);
  const [modalStudyId, setModalStudyId] = useState(0);
  const [modalStudyDesc, setModalStudyDesc] = useState('');

  // Admin & Parameters state
  const [isAdmin, setIsAdmin] = useState(false);
  const [modalParamsOpen, setModalParamsOpen] = useState(false);
  const [scoreMinimo, setScoreMinimo] = useState('350');
  const [aprovacaoDireta, setAprovacaoDireta] = useState('0');
  const [isSavingParams, setIsSavingParams] = useState(false);

  const cnpjMask = new StringMask('00.000.000/0000-00');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyCpfCnpjMask = (value) => {
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length <= 11) {
      return new StringMask('000.000.000-00').apply(numericValue);
    } else {
      return new StringMask('00.000.000/0000-00').apply(numericValue);
    }
  };

  const applyFilter = useCallback(() => {
    let url = 'study?';
    if (studyStatus !== 0) {
      url += `IN_STATUS=${studyStatus}&`;
    }
    if (studyIdDm014 !== '') {
      url += `ID_DM014=${studyIdDm014}&`;
    }
    if (studyName !== '') {
      url += `NM_CLIENTE=${studyName}&`;
    }
    if (studyCnpj !== '') {
      const cnpjCpf = studyCnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '');
      url += `NR_CPFCNPJ=${cnpjCpf}&`;
    }
    api
      .get(url)
      .then((response) => {
        setStudyList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [studyIdDm014, studyName, studyCnpj, studyStatus]);

  const cleanFields = useCallback(() => {
    setStudyCnpj('');
    setStudyIdDm014('');
    setStudyName('');
    setStudyStatus(0);
    applyFilter();
  }, []);

  // Check if user is admin
  useEffect(() => {
    api
      .get('user')
      .then((response) => {
        const userType = response.data?.data?.dm900?.IN_TIPO;
        if (userType === '1' || userType === 1) {
          setIsAdmin(true);
        }
      })
      .catch((err) => {
        console.log('Error checking user profile:', err);
      });
  }, []);

  // Load study params
  const loadStudyParams = useCallback(() => {
    api
      .get('study_params')
      .then((response) => {
        setScoreMinimo(response.data.data.score_minimo_aprovacao || '350');
        setAprovacaoDireta(response.data.data.aprovacao_direta || '0');
      })
      .catch((err) => {
        console.log('Error loading study params:', err);
      });
  }, []);

  const handleOpenParams = () => {
    loadStudyParams();
    setModalParamsOpen(true);
  };

  const handleSaveParams = () => {
    setIsSavingParams(true);
    api
      .put('study_params', {
        score_minimo_aprovacao: scoreMinimo,
        aprovacao_direta: aprovacaoDireta
      })
      .then((response) => {
        toast.success('Parâmetros salvos com sucesso!');
        setModalParamsOpen(false);
        setIsSavingParams(false);
      })
      .catch((err) => {
        toast.error('Erro ao salvar parâmetros');
        setIsSavingParams(false);
        console.log(err);
      });
  };

  const deleteStudy = useCallback(
    (id) => {
      api
        .delete(`study`, {
          params: { ID_DM014: id }
        })
        .then((response) => {
          setModalStatus(false);
          if (response.status === 202) {
            toast.success('Estudo removido com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          applyFilter();
        })
        .catch((error) => {
          setModalStatus(false);
          toast.success(error);
        });
    },
    [modalStudyId]
  );

  useEffect(() => {
    applyFilter();
  }, [studyStatus]);

  const statusDescription = (status) => {
    switch (status) {
      case '1':
        return 'ENVIADO';
      case '2':
        return 'AGUARDANDO APROVAÇÃO';
      case '3':
        return 'APROVADO';
      case '4':
        return 'NÃO APROVADO';
      default:
        return 'NÃO DEFINIDO';
    }
  };

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Estudos...</h1>
        </ContainerLoading>
      ) : (
        <Container fluid>
          <ContainerStudies>
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <h2>Lista de Estudos</h2>
                <p className="text-muted">
                  Gerencie e consulte todos os estudos de viabilidade energética
                </p>
              </div>
              {isAdmin && (
                <ButtonDefault
                  Width={'180px'}
                  Margin={'0'}
                  Text={
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                      <FaCog /> Parâmetros
                    </span>
                  }
                  onClick={handleOpenParams}
                />
              )}
            </div>

            {/* Seção de Filtros */}
            <div className="filter-section">
              <h5 style={{ 
                color: 'var(--primary-color)', 
                fontWeight: 'var(--font-weight-semibold)',
                marginBottom: 'var(--spacing-lg)'
              }}>
                Filtros de Busca
              </h5>
              <Row>
                <Col xs={12} md={3}>
                  <SelectDefault
                    Width={'100%'}
                    Margin={'10px 0px 15px 0px'}
                    Text={'Situação'}
                    value={`${studyStatus}`}
                    onChange={(e) => {
                      setStudyStatus(e.target.value);
                    }}>
                    <option value="0">NÃO DEFINIDO</option>
                    <option value="1">ENVIADO</option>
                    <option value="2">AGUARDANDO APROVAÇÃO</option>
                    <option value="3">APROVADO</option>
                    <option value="4">NÃO APROVADO</option>
                  </SelectDefault>
                </Col>
                <Col xs={12} md={3}>
                  <InputDefault
                    placeholder="Código do Estudo"
                    Width={'100%'}
                    Margin={'10px 0px 15px 0px'}
                    Text={'Código'}
                    value={`${studyIdDm014}`}
                    onChange={(e) => setStudyIdDm014(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === 'Enter') {
                        applyFilter();
                      }
                    }}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputDefault
                    placeholder="Nome do Cliente"
                    Width={'100%'}
                    Margin={'10px 0px 15px 0px'}
                    Text={'Nome'}
                    value={`${studyName}`}
                    onChange={(e) => setStudyName(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === 'Enter') {
                        applyFilter();
                      }
                    }}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputDefault
                    placeholder="CPF/CNPJ"
                    Width={'100%'}
                    Margin={'10px 0px 15px 0px'}
                    Text={'CPF/CNPJ'}
                    value={`${studyCnpj}`}
                    onChange={(e) => setStudyCnpj(applyCpfCnpjMask(e.target.value))}
                    onKeyUp={(e) => {
                      if (e.key === 'Enter') {
                        applyFilter();
                      }
                    }}
                  />
                </Col>
              </Row>
              <div className="d-flex gap-3">
                <ButtonDefault
                  Width={'150px'}
                  Margin={'20px 0px 0px 0px'}
                  Text="Buscar"
                  onClick={applyFilter}
                />
                <ButtonDefault
                  Width={'150px'}
                  Margin={'20px 0px 0px 0px'}
                  Text="Limpar"
                  onClick={() => {
                    cleanFields();
                  }}
                />
              </div>
            </div>

            {/* Seção da Tabela */}
            <div className="table-section">
              <h5 style={{ 
                color: 'var(--primary-color)', 
                fontWeight: 'var(--font-weight-semibold)',
                marginBottom: 'var(--spacing-lg)'
              }}>
                Estudos Encontrados ({studyList.length})
              </h5>
              <div className="table-responsive">
                <Table striped hover>
                  <thead>
                    <tr>
                      <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                      <th style={{ width: '20%' }}>Nome do Cliente</th>
                      <th style={{ width: '10%' }}>CPF/CNPJ</th>
                      <th style={{ width: '5%' }}>Alteração</th>
                      <th style={{ width: '10%', textAlign: 'center' }}>Situação</th>
                      <th style={{ width: '10%', textAlign: 'center' }}>SPC</th>
                      <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                {studyList.map((study) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{study.ID_DM014}</td>
                    <td>{study.NM_CLIENTE}</td>
                    <td>{applyCpfCnpjMask(study.NR_CPFCNPJ)}</td>
                    <td>{moment(study.DT_ALTERACAO).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{statusDescription(study.IN_STATUS)}</td>
                    <td style={{ textAlign: 'center' }}>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <div>Data: </div>
                            <div>{study.DT_CONSULTA_SPC || 'N/A'}</div>
                            <div>Protocolo: </div>
                            <div>{study.ID_CONSULTA_SPC || 'N/A'}</div>
                            <div>Score: </div>
                            <div>{study.QT_SCORE_SPC || 'N/A'}</div>
                            <div>Classe: </div>
                            <div>{study.IN_RISCO_INADIMPLENCIA_SPC || 'N/A'}</div>
                          </Tooltip>
                        }>
                        <span
                          style={{
                            display: 'inline-block',
                            padding: 'var(--spacing-xs) var(--spacing-sm)',
                            backgroundColor: 'var(--primary-color)',
                            color: 'var(--text-light)',
                            borderRadius: 'var(--border-radius-lg)',
                            cursor: 'pointer',
                            fontSize: 'var(--font-size-sm)',
                            fontWeight: 'var(--font-weight-medium)'
                          }}>
                           Score {study?.QT_SCORE_SPC}
                        </span>
                      </OverlayTrigger>
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <GenericActionMenu
                        actions={[
                          {
                            key: 'view-pdf',
                            label: 'Visualizar PDF',
                            icon: FaFileAlt,
                            onClick: () => {
                              try {
                                const token = localStorage.getItem('TOKEN');
                                const pdfUrl = `${baseURL}study_pdf?ID_DM014=${study.ID_DM014}&token=${token}`;
                                console.log('Abrindo PDF:', pdfUrl);
                                console.log('Token:', token ? 'Token encontrado' : 'Token não encontrado');
                                
                                const newWindow = window.open(pdfUrl, '_blank');
                                if (!newWindow) {
                                  toast.error('Bloqueador de popup ativo. Permita popups para visualizar o PDF.');
                                }
                              } catch (error) {
                                console.error('Erro ao abrir PDF:', error);
                                toast.error('Erro ao abrir o PDF');
                              }
                            }
                          },
                          {
                            key: 'view',
                            label: 'Visualizar',
                            icon: FaEye,
                            onClick: () => {
                              // Adicionar lógica de visualização se necessário
                              console.log('Visualizar estudo:', study.ID_DM014);
                            }
                          },
                          { type: 'divider' },
                          {
                            key: 'edit',
                            label: 'Editar',
                            icon: FaEdit,
                            to: `/study/edit/${study.ID_DM014}` // Navegação via Link
                          },
                          {
                            key: 'delete',
                            label: 'Excluir',
                            icon: FaTrashAlt,
                            variant: 'danger',
                            onClick: () => {
                              setModalStudyId(study.ID_DM014);
                              setModalStudyDesc(study.NM_CLIENTE);
                              setModalStatus(true);
                            }
                          }
                        ]}
                        buttonLabel={`Ações para ${study.NM_CLIENTE}`}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
              </div>
            </div>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalStatus}
            handleClose={() => setModalStatus(false)}
            handleConfirm={deleteStudy}
            handleCancel={() => setModalStatus(false)}
            modalTitleText={`Deseja excluir o estudo #${modalStudyId}?`}
            modalText={modalStudyDesc}
            id={modalStudyId}
          />

          {/* Modal de Parâmetros do Estudo */}
          <Modal
            open={modalParamsOpen}
            onClose={() => setModalParamsOpen(false)}
            aria-labelledby="modal-params-title">
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 480,
                bgcolor: 'rgb(241, 241, 241)',
                border: 'none',
                boxShadow: 24,
                borderRadius: '10px',
                padding: '30px'
              }}>
              <h3
                style={{
                  textAlign: 'center',
                  color: 'var(--primary-color)',
                  fontWeight: 'var(--font-weight-semibold)',
                  marginBottom: '25px'
                }}>
                Parâmetros do Estudo
              </h3>

              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: 'var(--font-weight-medium)',
                    color: 'var(--text-muted)'
                  }}>
                  Score mínimo para aprovação
                </label>
                <input
                  type="number"
                  value={scoreMinimo}
                  onChange={(e) => setScoreMinimo(e.target.value)}
                  disabled={aprovacaoDireta === '1'}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    fontSize: '14px',
                    opacity: aprovacaoDireta === '1' ? 0.5 : 1
                  }}
                />
                {aprovacaoDireta === '1' && (
                  <small style={{ color: '#888', display: 'block', marginTop: '4px' }}>
                    O score mínimo não é utilizado quando a aprovação direta está ativa.
                  </small>
                )}
              </div>

              <div style={{ marginBottom: '25px' }}>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    cursor: 'pointer',
                    fontWeight: 'var(--font-weight-medium)',
                    color: 'var(--text-muted)'
                  }}>
                  <input
                    type="checkbox"
                    checked={aprovacaoDireta === '1'}
                    onChange={(e) => setAprovacaoDireta(e.target.checked ? '1' : '0')}
                    style={{
                      width: '18px',
                      height: '18px',
                      cursor: 'pointer'
                    }}
                  />
                  Aprovação direta
                </label>
                <small style={{ color: '#888', display: 'block', marginTop: '4px', marginLeft: '28px' }}>
                  Quando ativa, o estudo será aprovado e enviado para assinatura independente do score obtido.
                </small>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                <ButtonDefault
                  Width={'180px'}
                  Margin={'0'}
                  Text={isSavingParams ? 'Salvando...' : 'Salvar'}
                  onClick={handleSaveParams}
                  disabled={isSavingParams}
                />
                <ButtonDefault
                  Width={'180px'}
                  Margin={'0'}
                  Text="Cancelar"
                  onClick={() => setModalParamsOpen(false)}
                />
              </div>
            </Box>
          </Modal>

          <Footer />
        </Container>
      )}
    </>
  );
};

export default StudyList;
